import React, { FC } from 'react';
import i18next from 'i18next';

interface ErrorPopupRestylingProps {
  open: boolean;
  onClose: () => void;
  casText?: string;
  oro?: boolean;
}

const getErrorText = (casText?: string) => {
  const lang = i18next.language;
  switch (lang) {
    case 'eus':
      return 'Errore bat egon da. Mesedez, saiatu berriro, eta errorea konpontzen ez bada, jarri harremanetan zure bankuarekin.';
    case 'cat':
      return "Hem detectat un error. Si us plau, torna-ho a intentar; si l'error persisteix, posa't en contacte amb la teva entitat bancària.";
    case 'gal':
      return 'Detectamos un erro. Por favor, volve intentalo e se o erro persiste ponte en contacto coa túa entidade bancaria.';
    case 'cas':
      return casText || '';
    default:
      return 'Hemos detectado un error. Por favor, vuelve a intentarlo y si el error persiste ponte en contacto con tu entidad bancaria.';
  }
};

const ErrorPopupRestyling: FC<ErrorPopupRestylingProps> = ({
  open,
  onClose,
  casText,
  oro,
}) => {
  return (
    <div
      className={`modal modal--small ${open ? 'is-active' : ''}`}
      id="modal-error-restyling"
    >
      <div className="modal__background" />
      <div className="modal__card u-text-center">
        <header className="modal__card-head u-flex">
          <div className={oro ? 'modal__card-title-oro' : 'modal__card-title'}>
            Vaya, algo no ha ido bien...
          </div>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            href="#"
            className="modal__card-close"
            modal-cerrar="true"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onClose();
            }}
          >
            <div className="icon icon-medium icon--close">
              {/* Aquí podrías usar el mismo IconX si lo necesitas */}
            </div>
          </a>
        </header>
        <section className="modal__card-body">
          <p>{getErrorText(casText)}</p>
          <div className="modal__botonera">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              href={process.env.REACT_APP_TARJETA_ORO_URL || './tarjeta-oro'}
              className={oro ? 'btn btn-oro' : 'btn btn-primary'}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onClose();
              }}
            >
              {i18next.t('entendido')}
            </a>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ErrorPopupRestyling;
